import { AddLayoutRequest, SiteControlLayout, SiteControlWidget } from '@scaleaq/sitecontrol-lib';

export const getAddLayoutRequestFromSiteControlLayout = ({
  siteControlLayout: { name, pageName, widgets },
  source,
}: {
  source: string;
  siteControlLayout: SiteControlLayout;
}): AddLayoutRequest => {
  return {
    name,
    pageName,
    source,
    widgets: widgets.map(({ id, ...rest }: SiteControlWidget): Omit<SiteControlWidget, 'id'> => {
      void id;
      return rest;
    }),
  };
};
